const PhoneNumber = (val) => {
    const regex = /^[+0-9]{6,14}$/i;
    const valid = !val || regex.test(val);

    return [
        valid,
        valid ? null : 'Please enter a valid phone number',
    ]
}

export default PhoneNumber;